/** @format */

export const NAMESPACE = '/wc/v3/payments';
export const STORE_NAME = 'wc/payments/multi-currency';
